import { MARKED_OPTIONS, MarkedOptions, MarkedRenderer } from 'ngx-markdown';
import { createMarkedOptions } from './base-marked-config';

export function overrideMarkedOptionsRenderer(): MarkedOptions {
  const renderer = new MarkedRenderer();

  renderer.html = (htmlBlock) => {
    const tablePattern = /<table[^>]*class="[^"]*mcq-options[^"]*"[^>]*>([\s\S]*?)<\/table>/gi;

    // check if we have any MCQ option tables
    if (!tablePattern.test(htmlBlock.raw)) {
      return MarkedRenderer.prototype.html.call(renderer, htmlBlock);
    }

    // reset regex state since we used test()
    tablePattern.lastIndex = 0;

    const modifiedHtml = htmlBlock.raw.replace(tablePattern, (fullMatch, tableContent) => {
      let modifiedContent;

      // explicit tbody structure
      if (tableContent.includes('<tbody>')) {
        const tbodyPattern = /<tbody>([\s\S]*?)<\/tbody>/gi;
        modifiedContent = tableContent.replace(tbodyPattern, (tbodyMatch: string, tbodyContent: string) => {
          const trPattern = /<tr[^>]*>([\s\S]*?)<\/tr>/gi;
          let rowIndex = 0;
          return tbodyContent.replace(trPattern, (__: string, trContent: string) => {
            const label = String.fromCharCode(65 + rowIndex); // A, B, C, etc.
            rowIndex++;
            return `<tr label="${label})">${trContent}</tr>`;
          });
        });
      } else {
        // no explicit thead/tbody - first tr as header
        const trPattern = /<tr[^>]*>([\s\S]*?)<\/tr>/gi;
        let rowIndex = 0;
        let isFirstRow = true;
        modifiedContent = tableContent.replace(trPattern, (trMatch: string, trContent: string) => {
          if (isFirstRow) {
            isFirstRow = false;
            return trMatch;
          } else {
            const label = String.fromCharCode(65 + rowIndex); // A, B, C, etc.
            rowIndex++;
            return `<tr label="${label})">${trContent}</tr>`;
          }
        });
      }

      // reconstruct the full table with modified content
      return fullMatch.replace(tableContent, modifiedContent);
    });

    return modifiedHtml;
  };

  return createMarkedOptions({ renderer });
}

export const McqTableMarkedOptionsProvider = {
  provide: MARKED_OPTIONS,
  useFactory: overrideMarkedOptionsRenderer,
};
